export default class StoreTables {
    
    idTable: string | undefined;
    value: number | null | undefined;
    constructor(idTable: string, value: number){
        this.idTable = idTable;
        this.value = value;
    }
}
